import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

/**
 * Compact button to copy a transaction reference into the clipboard.
 * Use anywhere we display a code (Track page, banner, confirmation, etc.).
 */
export default function CopyRefButton({ code, label = "Copier la référence", compact = false }) {
  const [copied, setCopied] = useState(false);

  const copy = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      toast.success(`Référence ${code} copiée`, { duration: 2200 });
      setTimeout(() => setCopied(false), 1800);
    } catch (_e) {
      toast.error("Impossible de copier — copiez manuellement.");
    }
  };

  if (compact) {
    return (
      <button
        type="button"
        onClick={copy}
        className={`inline-flex items-center gap-1 rounded-md p-1 transition ${
          copied
            ? "text-emerald-600 bg-emerald-50"
            : "text-gray-400 hover:text-[var(--sl-primary)] hover:bg-[var(--sl-primary)]/10"
        }`}
        aria-label={label}
        title={label}
        data-testid="copy-ref-btn"
      >
        {copied ? <Check size={14} /> : <Copy size={14} />}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={copy}
      className={`inline-flex items-center gap-1.5 rounded-full text-xs font-medium px-3 py-1.5 transition ${
        copied
          ? "bg-emerald-100 text-emerald-700"
          : "bg-[var(--sl-primary)]/10 text-[var(--sl-primary)] hover:bg-[var(--sl-primary)]/20"
      }`}
      data-testid="copy-ref-btn"
    >
      {copied ? <Check size={13} /> : <Copy size={13} />}
      {copied ? "Copié" : "Copier"}
    </button>
  );
}
